import api from "@/api";
import axios from "axios";

export default {
  login({ commit }, user) {
    return new Promise((resolve, reject) => {
      api.login(user, (err, response) => {
        if (err) return reject(err);
        commit("LOGIN", response);
        resolve();
      });
    });
  },

  register({ commit }, customer) {
    return new Promise((resolve, reject) => {
      api.register(customer, (err, response) => {
        if (err) return reject(err);
        commit("LOGIN", response);
        resolve(response.customer);
      });
    });
  },

  registerMotorized({ commit }, motorized) {
    return new Promise((resolve, reject) => {
      api.registerMotorized(motorized, (err, response) => {
        if (err) return reject(err);
        resolve(response.motorized);
      });
    });
  },

  async customer({ commit }) {
    const { data } = await api.customer();
    const mercadoFlexId = Boolean(data.mercadoLibreId);
    commit("STORE_MERCADO_FLEX_INTEGRATION", mercadoFlexId);
    commit("STORE_CUSTOMER", data);
    return data;
  },

  checkCulqi({ commit }, data) {
    return new Promise((resolve, reject) => {
      api.culqi(data, (err, customer) => {
        if (err) return reject(err);
        resolve(customer);
      });
    });
  },

  changePassword({ commit }, data) {
    return new Promise((resolve, reject) => {
      api.changePassword(data, (err, response) => {
        if (err) return reject(err);
        resolve(response);
      });
    });
  },

  update({ commit }, customer) {
    return new Promise((resolve, reject) => {
      api.update(customer, (err, response) => {
        if (err) return reject(err);
        commit("STORE_CUSTOMER", response);
        resolve(response);
      });
    });
  },

  getApiKey({ commit }, params = {}) {
    return new Promise((resolve, reject) => {
      api.getApiKey(params, (err, apiKey) => {
        if (err) return reject(err);
        commit("STORE_API_KEY", apiKey);
        resolve();
      });
    });
  },
  getApiReportServices({ commit }) {
    return new Promise((resolve, reject) => {
      api.getReportServices((err, services) => {
        if (err) return reject(err);
        commit("STORE_REPORT_SERVICES", services);
        resolve();
      });
    });
  },
  getApiReportOrders({ commit }) {
    return new Promise((resolve, reject) => {
      api.getReportOrders((err, reportOrders) => {
        if (err) return reject(err);
        commit("STORE_REPORT_ORDERS", reportOrders);
        resolve();
      });
    });
  },

  createCard({ commit }, payload) {
    return new Promise((resolve, reject) => {
      api.cards.create(payload, (err, result) => {
        if (err) return reject(err);
        commit("STORE_CARD", result.card);
        resolve(result);
      });
    });
  },

  deleteCard({ commit }, data) {
    return new Promise((resolve, reject) => {
      api.cards.delete(data, (err, result) => {
        if (err) return reject(err);
        commit("REMOVE_CARD", data.mpCardId);
        resolve(result);
      });
    });
  },

  createFrequent({ commit }, data) {
    return new Promise((resolve, reject) => {
      api.frequents.create(data, (err, result) => {
        if (err) return reject(err);
        commit("STORE_FREQUENTS", result);
        resolve(result);
      });
    });
  },

  deleteFrequent({ commit }, frequentId) {
    return new Promise((resolve, reject) => {
      api.frequents.delete(frequentId, (err, result) => {
        if (err) return reject(err);
        commit("STORE_FREQUENTS", result);
        resolve(result);
      });
    });
  },

  async getOrders({ commit, state }) {
    const { ordersFilter } = state;
    let orders = [];
    try {
      const response =
        ordersFilter === "nirex"
          ? await api.orders.getAll()
          : await api.orders.getMercadoFlexOrdersFromApi();
      orders = response.data;
    } catch (err) {
      throw new Error(err);
    }
    commit("STORE_ORDERS", orders);
    return orders;
  },

  createOrder({ commit }, data) {
    return new Promise((resolve, reject) => {
      api.orders.create(data, (err, result) => {
        if (err) return reject(err);
        commit("STORE_ORDER", result.order);
        resolve(result);
      });
    });
  },

  async createOrderSameday({ commit }, data) {
    return new Promise((resolve, reject) => {
      api.orders.createSameday(data, (err, result) => {
        if (err) return reject(err);
        commit("STORE_ORDER", result.order);
        resolve(result);
      });
    });
  },
  async createOrderExpress({ commit }, data) {
    return new Promise((resolve, reject) => {
      api.orders.createExpress(data, (err, result) => {
        if (err) return reject(err);
        commit("STORE_ORDER", result.order);
        resolve(result);
      });
    });
  },
  async createOrderExpressReserved({ commit }, data) {
    return new Promise((resolve, reject) => {
      api.orders.createExpressReserved(data, (err, result) => {
        if (err) return reject(err);
        commit("STORE_ORDER", result.order);
        resolve(result);
      });
    });
  },
  async createOrderMercadoFlex({ commit }, data) {
    return new Promise((resolve, reject) => {
      api.orders.createMercadoFlex(data, (err, result) => {
        if (err) return reject(err);
        commit("STORE_ORDER", result.order);
        resolve(result);
      });
    });
  },

  cancelOrder({ commit }, { order, taxes }) {
    return new Promise((resolve, reject) => {
      api.orders.cancelOrder(order.id, taxes, (err, res) => {
        if (err) return reject(err);
        resolve(res);
      });
    });
  },

  updateOrder({ commit }, data) {
    return new Promise((resolve, reject) => {
      api.orders.update(data.order.id, data, (err, res) => {
        if (err) return reject(err);
        resolve(res);
      });
    });
  },

  async loadZones({ commit }) {
    try {
      const { data } = await axios.get(
        process.env.VUE_APP_NIREX_API_URL + "/zones"
      );
      commit("SET_ZONES", data);
    } catch (error) {
      console.log("No se cargaron las zonas");
    }
  },

  async loadZonesExpress({ commit }) {
    try {
      const { data } = await axios.get(
        process.env.VUE_APP_NIREX_API_URL + "/zonesExpress"
      );
      commit("SET_ZONES_EXPRESS", data);
    } catch (error) {
      console.log("No se cargaron las zonas express");
    }
  },

  async loadZonesMercadoFlex({ commit }) {
    try {
      const { data } = await axios.get(
        process.env.VUE_APP_NIREX_API_URL + "/zonesSamedayMercadoFlex"
      );
      commit("SET_ZONES_MERCADO_FLEX", data);
    } catch (error) {
      console.log("No se cargaron las zonas express");
    }
  },

  getTracking({ commit }, params = {}) {
    return new Promise((resolve, reject) => {
      api.tracking(params, (err, tracking) => {
        if (err) return reject(err);
        commit("STORE_TRACKING", tracking);
        resolve();
      });
    });
  },

  async matchTokenWithApiKey({ commit }, data) {
    return new Promise((resolve, reject) => {
      api.matchTokenApiKey(data, (err, result) => {
        if (err) return reject(err);
        commit("STORE_MERCADO_FLEX_INTEGRATION", true);
        resolve(result);
      });
    });
  },

  async unlinkMercadoflexIntegration({ commit }, data) {
    return new Promise((resolve, reject) => {
      api.unlinkMercadoflexIntegration(data, (err, result) => {
        if (err) return reject(err);
        commit("STORE_MERCADO_FLEX_INTEGRATION", false);
        resolve(result);
      });
    });
  },

  getAvailableServices({ commit }) {
    return new Promise((resolve, reject) => {
      api.getAvailableServices((err, servicesObject) => {
        if (err) return reject(err);
        commit("STORE_AVAILABLE_SERVICES", servicesObject);
        resolve(servicesObject);
      });
    });
  },

  async createMercadoPagoClientAction({ commit }, payload) {
    return new Promise((resolve, reject) => {
      api.createMercadoPagoClient(payload, (error, result) => {
        if (error) return reject(error);
        commit("STORE_CUSTOMER", result);
        resolve(result);
      });
    });
  },

  async getOrdersFromMercadoFlex() {
    try {
      const { data } = await api.getOrdersFromMercadoFlex();
      return data;
    } catch (error) {
      throw new Error(error);
    }
  },

  async getShipmentsFromMercadoFlex({ commit }, idsArray) {
    const pendingShipmentsArray = idsArray.map((id) =>
      axios.get(
        `${process.env.VUE_APP_NIREX_API_URL}/customer/orders/mercadoflex/pending/${id}`
      )
    );
    try {
      const responses = await Promise.all(pendingShipmentsArray);
      return await Promise.all(
        responses
          .filter(
            ({ data }) =>
              !data.errors && data.status && data.status === "pending"
          )
          .map(({ data }) => data)
      );
    } catch (error) {
      throw new Error(error);
    }
  },

  async createMercadoFlexOrder({ commit }, data) {
    return new Promise((resolve, reject) => {
      api.createMercadoFlex(data, (error, result) => {
        if (error) return reject(error);
        commit("STORE_CUSTOMER", result.order);
        resolve(result);
      });
    });
  },
};
